var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatering(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 17,
    viewBox: "0 0 28 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "catering",
    transform: "translate(-5 -12.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M5.737,29.5H32.263a.739.739,0,0,0,0-1.478h-.774a12.574,12.574,0,0,0-8.857-11.287,3.265,3.265,0,0,0,.052-.54,3.684,3.684,0,1,0-7.368,0,3.265,3.265,0,0,0,.052.54A12.574,12.574,0,0,0,6.511,28.022H5.737a.739.739,0,0,0,0,1.478ZM19,13.978A2.22,2.22,0,0,1,21.211,16.2c0,.067-.015.133-.022.207a11.674,11.674,0,0,0-4.377,0c-.007-.074-.022-.14-.022-.207A2.22,2.22,0,0,1,19,13.978Zm0,3.7A11.078,11.078,0,0,1,30.016,28.022H7.984A11.078,11.078,0,0,1,19,17.674Z",
    transform: "translate(0 0)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M25.737,21.5a.739.739,0,0,0,0,1.478,5.912,5.912,0,0,1,5.895,5.913.737.737,0,1,0,1.474,0A7.392,7.392,0,0,0,25.737,21.5Z",
    transform: "translate(-5.263 -2.348)",
    fill: "#444"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatering);
export default __webpack_public_path__ + "static/media/catering.c10628ec3d4bf6e49aad612109d4d5ed.svg";
export { ForwardRef as ReactComponent };